import React, { useContext } from "react";
import { groupBy, flatMap } from "lodash";
import AGButton from "../../../components/Button";
import AGModal from "../../../components/Modal";
import { IMessageDetailModal } from "./messageDetailModal.props";
import { UserContext } from "../../../Provider";
import { formatDate } from "../../../utils/helper";

const MessageDetailModal: React.FC<IMessageDetailModal> = ({
  inboxDetail,
  toggleModal,
  visible,
  ...props
}: IMessageDetailModal) => {
  const user = useContext(UserContext);
  const grouped = groupBy(inboxDetail?.inboxRecipientsMappings, item => `${item.fkToIndividual?.fkOrg?.orgName}`);

  const receiverRegions = flatMap(inboxDetail?.receiverRegion, item => item.agnetRegion?.netRegionName);
  const receiverContries = flatMap(inboxDetail?.receiverRegion, item => item.country);

  return (
    <AGModal
      footer={
        <>
          <AGButton
            type="Secondary"
            onClick={toggleModal}
          >
            Close
          </AGButton>
        </>
      }
      title="Inquiry Details"
      toggleModal={toggleModal}
      visible={visible}
      isMaxContent
    >
      <div className="p-[1.4286rem] text-[#58585B] mobile2:!absolute mobile2:max-h-none max-h-[600px] overflow-y-auto">
        <div className="innerBox">
          <div className="flex flex-row py-2">
            <div className="font-semibold w-30 md:w-32">Inquiry Date</div>
            <div className="flex-1">{formatDate(inboxDetail?.sendDate)}</div>
          </div>

          <div className="mt-[0.5rem]">
            <p className="text-[0.875rem] font-bold text-[#58585B]">Inquiry Sender Organization - {inboxDetail?.fkFromIndividual?.fkOrg?.orgName}</p>
            <div className="flex flex-row py-2">
              <div className="w-30 md:w-32">Inquiry Sender:</div>
              <div className="flex-1">{`${inboxDetail?.fkFromIndividual?.firstName} ${inboxDetail?.fkFromIndividual?.lastName} <${inboxDetail?.fkFromIndividual?.individualEmailAddr}>`}</div>
            </div>
          </div>

          {Object.keys(grouped).map((group) => (
            <div className="mt-[0.5rem]">
              <p className="text-[0.875rem] font-bold text-[#58585B]">Inquiry Receiver Organization - {group}</p>
              <div className="flex flex-row py-2">
                <div className="w-30 md:w-32">Inquiry Receiver:</div>
                <div className="flex-1">
                  {grouped[group]?.map((e, index, array) => {
                    return (
                      <span
                        className="inline-block mr-[0.3571rem]"
                        key={index}
                      >
                        {`${e?.fkToIndividual?.firstName} ${e?.fkToIndividual?.lastName} <${e?.fkToIndividual?.individualEmailAddr
                          }> ${!(index === array.length - 1) ? "; " : ""}`}
                      </span>
                    );
                  })}
                </div>
              </div>
            </div>
          ))}

          <div className="mt-[0.5rem]">
            {
              inboxDetail?.cc &&
              <>
                <p className="text-[0.875rem] font-bold text-[#58585B]">CC</p>
                <p className="">

                  {inboxDetail?.cc?.split(",").map((e, index, array) => {
                    const ccIndiv = inboxDetail.listCCIndividuals?.find(f => f.individualEmailAddr === e);
                    if (ccIndiv) {
                      return (
                        <span
                          className="inline-block mr-[0.3571rem]"
                          key={index}
                        >
                          {`${ccIndiv.firstName} ${ccIndiv.lastName} <${ccIndiv.individualEmailAddr}> ${!(index === array.length - 1) ? "; " : ""}`}
                        </span>
                      );

                    } else {
                      return <span
                        className="inline-block mr-[0.3571rem]"
                        key={index}
                      >
                        {`${e} ${!(index === array.length - 1) ? "; " : ""}`}
                      </span>
                    }
                  })}
                </p>
              </>
            }

          </div>
          <div className="mt-[0.5rem]">
            <p className="text-[0.875rem] font-bold text-[#58585B] ">Subject</p>
            <p className="font-normal text-[#58585B] break-words">{inboxDetail?.subject}</p>
          </div>
          <div className="mt-[0.5rem]">
            <p className="text-[0.875rem] font-bold text-[#58585B]">Message</p>
            <p className="text-justify font-normal whitespace-pre-line break-words">{inboxDetail?.body}</p>
          </div>
          { inboxDetail?.fkComOffering?.fkOfferingType?.offeringTypeName && <div className="flex flex-col md:flex-row">
            <div className="w-full md:w-1/3 mt-[0.5rem]">
              <p className="text-[0.875rem] font-bold text-[#58585B]">Offering Type</p>
              <p className="">
                {inboxDetail?.fkComOffering?.fkOfferingType?.offeringTypeName ?? ""}
              </p>
            </div>

            <div className="w-full md:w-2/3 mt-[0.5rem]">
              <p className="text-[0.875rem] font-bold text-[#58585B]">Specialized {inboxDetail?.fkComOffering?.fkOfferingType?.offeringTypeName ?? ""}</p>
              <p className="">
                {inboxDetail?.offeringMainService?.mainServiceName}
              </p>
            </div>
          </div> }

          <div className="flex flex-col md:flex-row">
            <div className="w-full md:w-1/3 mt-[0.5rem]">
              <p className="text-[0.875rem] font-bold text-[#58585B]">Status</p>
              <p className="">
                {inboxDetail?.fkInquiryStatus?.status}
              </p>
            </div>

            { inboxDetail?.fkInquiry?.dealValue && <div className="w-full md:w-1/3 mt-[0.5rem]">
              <p className="text-[0.875rem] font-bold text-[#58585B]">Deal Value</p>
              <p className="">
                {inboxDetail?.fkInquiry?.dealValue}
              </p>
            </div> }

            { inboxDetail?.fkInquiry?.closeDate && <div className="w-full md:w-1/3 mt-[0.5rem]">
              <p className="text-[0.875rem] font-bold text-[#58585B]">Close Date</p>
              <p className="">
                {formatDate(inboxDetail?.fkInquiry?.closeDate)}
              </p>
            </div> }
          </div>
          
          <div className="flex flex-col md:flex-row">
            <div className="w-full md:w-1/3 mt-[0.5rem]">
              <p className="text-[0.875rem] font-bold text-[#58585B]">Sender Region</p>
              <p className="">
                {inboxDetail?.senderRegion?.agnetRegion?.netRegionName}
              </p>
            </div>

            <div className="w-full md:w-2/3 mt-[0.5rem]">
              <p className="text-[0.875rem] font-bold text-[#58585B]">Sender Country</p>
              <p className="">
                {inboxDetail?.senderRegion?.country}
              </p>
            </div>
          </div>
          
          <div className="flex flex-col md:flex-row">
            <div className="w-full md:w-1/3 mt-[0.5rem]">
              <p className="text-[0.875rem] font-bold text-[#58585B]">Receiver Region</p>
              <p className="">
                { receiverRegions && receiverRegions.join(', ') }
              </p>
            </div>

            <div className="w-full md:w-2/3 mt-[0.5rem]">
              <p className="text-[0.875rem] font-bold text-[#58585B]">Receiver Country</p>
              <p className="">
                { receiverContries && receiverContries.join(', ') }
              </p>
            </div>
          </div>

          { inboxDetail?.fkInquiry && <div className="flex flex-col md:flex-row">
            { inboxDetail?.fkInquiry?.fkBusinessGenerating && <div className="w-full md:w-1/3 mt-[0.5rem]">
              <p className="text-[0.875rem] font-bold text-[#58585B]">Business Generating</p>
              <p className="">
                {inboxDetail?.fkInquiry?.fkBusinessGenerating?.businessGeneratingType}
              </p>
            </div> }

            { inboxDetail?.fkInquiry?.fkRequestedServices && <div className="w-full md:w-1/3 mt-[0.5rem]">
              <p className="text-[0.875rem] font-bold text-[#58585B]">Requested Services</p>
              <p className="">
                { inboxDetail?.fkInquiry?.fkRequestedServices?.requestedServicesTypeName }
              </p>
            </div> }

            { inboxDetail?.fkInquiry?.fkTypeOfClient && <div className="w-full md:w-1/3 mt-[0.5rem]">
              <p className="text-[0.875rem] font-bold text-[#58585B]">Type of Client</p>
              <p className="">
                {inboxDetail?.fkInquiry?.fkTypeOfClient?.typeOfClientName}
              </p>
            </div> }
          </div> }
          
          { inboxDetail?.fkInquiry && <div className="flex flex-col md:flex-row">
            { inboxDetail?.fkInquiry?.onetimeFee && <div className="w-full md:w-1/3 mt-[0.5rem]">
              <p className="text-[0.875rem] font-bold text-[#58585B]">One-Time Fee</p>
              <p className="">
                {inboxDetail?.fkInquiry?.onetimeFee}
              </p>
            </div> }

            { inboxDetail?.fkInquiry?.recurringFee && <div className="w-full md:w-1/3 mt-[0.5rem]">
              <p className="text-[0.875rem] font-bold text-[#58585B]">Recurring Fee</p>
              <p className="">
                {inboxDetail?.fkInquiry?.recurringFee}
              </p>
            </div> }

            { inboxDetail?.fkInquiry?.fkFrequencyOfRecurringFee?.frequencyType && <div className="w-full md:w-1/3 mt-[0.5rem]">
              <p className="text-[0.875rem] font-bold text-[#58585B]">Frequency of Recurring Fee</p>
              <p className="">
                {inboxDetail?.fkInquiry?.fkFrequencyOfRecurringFee?.frequencyType}
              </p>
            </div> }
          </div> }

          { inboxDetail?.fkInquiry?.commentsRemarks && <div className="mt-[0.5rem]">
            <p className="text-[0.875rem] font-bold text-[#58585B]">Comments/Remarks</p>
            <p className="">
              {inboxDetail?.fkInquiry?.commentsRemarks}
            </p>
          </div> }
        </div>
      </div>
    </AGModal>
  );
};

export default React.memo(MessageDetailModal);
